'use strict';

function initSkiplinks() {
    $(document).ready(function() {
        const $links = $('.skip-link-text');

        // Arrow key navigation
        $links.on('keydown', function (e) {
            let index = $links.index(this);
            // Down arrow
            if (e.key === 'ArrowDown') {
                e.preventDefault();

                let nextIndex = (index + 1) % $links.length;

                $links.removeClass('active');
                $links.eq(nextIndex).addClass('active').focus();
            }

            // Up arrow
            if (e.key === 'ArrowUp') {
                e.preventDefault();

                let prevIndex = (index - 1 + $links.length) % $links.length;

                $links.removeClass('active');
                $links.eq(prevIndex).addClass('active').focus();
            }
        });

        // on click of skiplink management
        $links.on('click keydown', function (e) {
            if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
                return;
            }
            e.preventDefault(); // prevent scroll down

            const $element = $(this);
            const targetID = $element.attr('href');
            let $target = $(targetID);
            let $redirectUrl, $offsetTop = 0;
            switch(targetID) {
                case "openSearch":
                    $('.js-search-link').trigger("click");
                    break;
                case "openMenu":
                    const $menuItem = $(".menu-list ul li.has-sub-menu");
                    $menuItem.first().find(".level1-cat-name").focus();
                    $(".hamburger-icon").focus();
                    break;
                case "openAccount":
                    if(window.User.isCustomerAuthenticated) {
                        $redirectUrl = $(".signin-anchor.registered").attr("href");
                        window.location.href = $redirectUrl;
                    } else {
                        $(".signin-anchor").trigger("click");
                        $(".login-redesign-username input.loginorregister").focus();
                    }
                    break;
                case "openCart":
                case "openHome":
                case "openContact":
                    $redirectUrl = $element.attr('data-href');
                    window.location.href = $redirectUrl;
                    break;
                case "openOptions":
                    if($(".promo-list").length) {
                        $target = $(".promo-list");
                    } else {
                        $target = $(".cta-wrapper");
                    }
                    $offsetTop = 150;
                    $target = $(".add-to-cart-wrapper button");
                    break;
                case "openShipping":
                    $offsetTop = 150;
                    $target = $("#cart-checkout-button");
                    break;
                case "#pdp-accordion":
                    $offsetTop = 150;
                    $target = $("#pdp-accordion .pdp-accordion__header").first().attr("tabindex", "0");
                default:
                    break;
            }
            
            $links.removeClass('active');
            setTimeout(function() {
                $(".nav-assist-container li:first-child a").addClass('active');
                $('.nav-assistant').removeClass('focused-skiplinks'); // hide skiplinks on click of links
            }, 100);
            // scroll to active target
            if($target.length) {
                window.scrollTo({
                    top: $target.offset().top - $offsetTop,
                    behavior: 'smooth'
                });
                if(targetID == "footer") {
                    $(".newsletter-form-container .email").focus();
                } else {
                    $target.focus();  // Accessibility focus handling
                }
            }
        });

        // ESC CLOSE
        $(document).on('keydown', function (e) {
            // Always allow Escape to close
            if (e.key === 'Escape') {
                $('.nav-assistant').removeClass('focused-skiplinks');
                return;
            }

            // Handle Tab only for keyboard navigation
            if (e.key === 'Tab') {
                setTimeout(function () {
                    const $focused = $(document.activeElement);
                    // Keep open if focus is still inside skiplinks
                    if ($focused.closest('.nav-assistant').length === 0) {
                        $('.nav-assistant').removeClass('focused-skiplinks');
                    }
                }, 0);
            }
        });
    });

    $('.nav-assistant a').on('focus', function () {
        $('.nav-assistant').addClass('focused-skiplinks');
    });

    $('.nav-assistant a').on('blur', function () {
        // wait for next focused element
        setTimeout(function () {
            if (!$('.nav-assistant').find(':focus').length) {
                $('.nav-assistant').removeClass('focused-skiplinks');
            }
        }, 0);
    });
}


/**
 * @function init
 * @description Initializes skiplinks
 */
export default {
    init: function () {
        initSkiplinks();
    }
};